<template>
    <v-dialog
        v-model="value"
        fullscreen
        hide-overlay
        persistent
        no-click-animation
        transition="dialog-bottom-transition"
    >
        <div class="white" style="margin-top: 8px;height: calc(100% - 15px); padding-right: 45px;">
            <div
                class="v-flex primary white"
                style="border-radius: 4px; margin-left: 75px"
            >
                <c-site-title :site="site" class="pl-2" style="padding-top: 2px" />
                <v-spacer />
                <v-btn
                    text
                    @click="onClose"
                    class="pl-0 pr-0"
                >
                    <v-icon size="22" color="white">mdi-close</v-icon>
                </v-btn>
            </div>
            <div class="w-100 mt-5">
                <t-site
                    :key       = "refresh"
                    ref        = "tabs"
                    :site      = "site"
                    :tab-index = tabIndex
                    @close     = "onClose"
                    @refresh   = "onRefresh"
                    @saved     = "onSaved"
                    @type      = "onType"
                    @customer  = "onCustomer"
                />
            </div>
        </div>
    </v-dialog>
</template>

<script>

import Core       from "@/modules/core/service/Core";
import Site       from "@/modules/msd/unit/service/Site";
import TSite      from "@/modules/msd/unit/components/dialog/TSite";
import CSiteTitle from "@/modules/msd/unit/components/controlls/CSiteTitle";

export default {
    name: "DSite",
    components: {
        CSiteTitle,
        TSite
    },

    props: {
        value: {

        },

        siteId: {
            required: false,
            type    : Number,
            default : function () {
                return null;
            }
        },

        tabIndex: {
            required: false,
            type    : Number,
            default : function () {
                return null;
            }
        },
    },

    data: () => ({
        site: null,
        refresh: 0
    }),

    watch: {
        value () {
            if (this.value) {
                this.loadSite();
            } else {
                this.$store.dispatch("findSiteById", this.siteId);
            }
        },
    },

    computed: {
    },

    methods: {
        onClose () {
            this.site = null;
            this.$emit("close", false);
            this.$emit("input", false);
        },

        onRefresh () {
            this.loadSite();
        },

        onSaved () {
            this.loadSite();
            Core.fire.saved(this, this.site);
        },

        onType (event) {
            this.site = event;
            // e.g. the disposition checks a device type conflict of the unit again (HCIT-943)
            this.$emit("type", event);
        },

        onCustomer () {
            this.loadSite();
            this.$emit("customer");
        },

        loadSite () {
            if (this.siteId) {
                Site.site(this.siteId, (data) => {
                    this.site = data;
                })
            }
        }
    }
}
</script>

<style scoped>

</style>